import React from 'react';

// todo: 上传错误到服务器，添加后台错误管理系统
const logErrorToMyService = (err, info) => {
  console.log(err, info); // eslint-disable-line
};

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    logErrorToMyService(error, info);
  }

  render() {
    if (this.state.hasError) {
      return <h1>Oooooops! Something went wrong, please try later.</h1>;
    }

    return this.props.children;
  }
}
